import React from 'react';

import { RehireEligibleText } from './utils/rehire-eligible-types';

type InputProps = {
  employee: Employee;
};

export const employeeStatusText = (employee: Employee) => {
  if (employee.isCurrentEmployee) {
    return 'Current Employee';
  }

  if (!employee.EndEmploymentReason) {
    return 'Terminated';
  }

  return `Terminated - ${employee.EndEmploymentReason.endReasonDescription}`;
};

export const EmployeeStatus = ({ employee }: InputProps) => {
  const showReasonExplanation = !employee.isCurrentEmployee && employee.endReasonExplanation;

  return (
    <div>
      <span className={employee.isCurrentEmployee ? '' : 'u-color-red'}>
        {employeeStatusText(employee)}
      </span>
      {showReasonExplanation ? (
        <div className="typo-subtitle">{employee.endReasonExplanation}</div>
      ) : null}
      {!employee.isCurrentEmployee && employee.rehireEligible ? (
        <div className="u-margin-top-md typo-subtitle">
          Rehire Eligible: {RehireEligibleText[employee.rehireEligible]}
        </div>
      ) : null}
    </div>
  );
};
